import instance from "../../../api";

export const WorkflowRequestService = {
  async getRequests(filters: Object) {
    return instance
      .get("workflow-requests/", { params: filters })
      .then((response) => response.data);
  },

  async submitRequest(payload: any) {
    return instance
      .post("workflow-requests/", payload)
      .then((response) => response.data);
  },

  async submitRecovery(payload: any) {
    return instance
      .post("loan/recover-loan/", payload)
      .then((response) => response.data);
  },

  async getRequestDetails(id: string) {
    return instance
      .get(`workflow-requests/${id}/`)
      .then((response) => response.data);
  },

  // to be removed
  async getWorkflowLevel(filters: Object) {
    return instance
      .get("workflow-levels/", {
        params: filters,
      })
      .then((response) => response.data);
  },
};
